import React from "react";

const PlayIcon = ({ width = 23, height = 23}) => {
  return (
        <svg width={width} height={height} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.91748 13.552C5.84665 16.4812 10.595 16.4812 13.5241 13.552" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.5241 2.94688C10.595 0.0177082 5.84665 0.0177082 2.91748 2.94688" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M1.16584 5.77295C0.88501 6.57378 0.754176 7.41128 0.75001 8.24962C0.754176 9.08712 0.884176 9.92462 1.16584 10.7254" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M15.2758 5.77368C15.5567 6.57451 15.6875 7.41201 15.6908 8.24951C15.6875 9.08785 15.5567 9.92535 15.2758 10.7262" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.33835 5.79778L10.5734 7.71111C10.9825 7.95278 10.9825 8.54528 10.5734 8.78695L7.33835 10.7003C6.92169 10.9469 6.39502 10.6461 6.39502 10.1619V6.33611C6.39502 5.85195 6.92169 5.55111 7.33835 5.79778V5.79778Z" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

  );
};

export default PlayIcon;
